import { render, staticRenderFns } from "./TilHeader.vue?vue&type=template&id=24a977d3"
import script from "./TilHeader.vue?vue&type=script&lang=js"
export * from "./TilHeader.vue?vue&type=script&lang=js"
import style0 from "./TilHeader.vue?vue&type=style&index=0&id=24a977d3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports